import { Link } from 'react-router-dom';

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">Features</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4 leading-tight">
            Why Vigorbuy Sheet Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-950 rounded-2xl p-8 flex flex-col justify-between min-h-[280px]">
            <div>
              <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center mb-5">
                <span className="text-background-50 font-bold text-sm">S</span>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mb-3">
                Spreadsheet Database
              </h3>
              <p className="text-sm text-foreground-300 leading-relaxed">
                Organized and updated daily. Every product is categorized, verified, and linked directly for instant access.
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden min-h-[280px] group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20scene%20of%20fashion%20items%20shoes%20bags%20and%20accessories%20elegantly%20arranged%20on%20wooden%20table%20with%20soft%20candlelight%20glow%20editorial%20lifestyle%20photography%20rich%20textures%20sophisticated%20composition%20cozy%20aesthetic%20no%20text%20no%20logos&width=800&height=600&seq=vigor-v2-feature-bg&orientation=landscape"
              alt="Vigorbuy buying guides featured"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/40"></div>
            <div className="relative z-10 p-8 flex flex-col justify-between h-full">
              <span className="inline-flex items-center gap-1.5 bg-background-50/90 text-foreground-950 text-xs font-semibold px-3 py-1.5 rounded-full w-fit">
                <i className="ri-book-open-line text-sm"></i>
                Buying Guides
              </span>
              <div>
                <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mb-2">
                  Smart Comparisons
                </h3>
                <p className="text-sm text-background-200/80 leading-relaxed">
                  Side-by-side product comparisons help you find the best value across categories.
                </p>
              </div>
            </div>
          </div>

          <Link
            to="/what-is-vigorbuy-sheet"
            className="rounded-2xl border border-background-200/70 bg-white p-8 flex flex-col justify-between min-h-[280px] hover:border-primary-300 transition-colors group cursor-pointer"
          >
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-3">
                What Is Vigorbuy Sheet?
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                Read our complete 2026 guide covering everything you need to know about the Vigorbuy Spreadsheet system.
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 group-hover:gap-2.5 transition-all">
                Read the full guide
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
            <div className="mt-4 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20interface%20mockup%20of%20organized%20product%20listing%20dashboard%20on%20laptop%20screen%20with%20warm%20ambient%20background%20bokeh%20lighting%20tech%20editorial%20style%20sophisticated%20minimal%20design%20no%20text%20no%20logos&width=500&height=200&seq=vigor-v2-guide-thumb&orientation=landscape"
                alt="Complete Vigorbuy Sheet guide thumbnail"
                className="w-full h-32 object-cover object-top rounded-lg"
              />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}